"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SITE_BASE_URL = exports.ASSETS_URL = exports.APP_VERSION = exports.APP_NAME = void 0;
var SITE_BASE_URL = exports.SITE_BASE_URL = "https://www.northwesternmutual.com",
  ASSETS_URL = exports.ASSETS_URL = "<%=assetsBaseUrl%>",
  APP_NAME = exports.APP_NAME = "nmx-static-react",
  APP_VERSION = exports.APP_VERSION = "0.0.1";